import type { NavigateFunction } from "react-router-dom";

// "Back" should return to the page the officer came from, wherever that was (the
// Forms page's Submissions list, a form's own list, a notification link...), not
// to one fixed address. React Router gives the first page of a visit the key
// "default": there is nothing earlier in the app to return to, so only then do
// we use `fallback` (a page opened straight from a bookmarked link, for example).
export function goBackOr(navigate: NavigateFunction, location: { key: string }, fallback: string) {
  if (location.key !== "default") navigate(-1);
  else navigate(fallback);
}
